import { server_connection } from 'config';
import { portal_url } from 'config';
import history from 'history.js';
import { auth, db } from 'firebase-db';
import { setDefaultSettings } from 'store/actions/fuse';
import { FuseDefaultSettings } from '@fuse';
import * as TableActions from 'main/components/tableSort/store/actions';
import * as DashboardActions from 'main/content/dashboard/store/actions';
import * as NotificationActions from 'main/content/notification/store/actions';
import _ from 'lodash';
import store from 'store';
import * as Actions from 'store/actions';
import firebase from 'firebase/app';
import * as moment from 'moment';

export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';
export const GO_TO_PROFILE = '[USER] GO TO PROFILE';
export const GO_TO_COURSE = '[USER] GO TO COURSE';
export const SET_TOKEN_CHECK = '[USER] SET TOKEN CHECK';
export const UPDATE_STUDENT_USER_COURSES = '[USER] UPDATE STUDENT USER COURSES';
export const UPDATE_USER_ROLES = '[USER] UPDATE USER ROLES';

export function setTokenCheck() {
    return {
        type: SET_TOKEN_CHECK
    }
}

export function setUserData(user, doNotUpdate) {
    return (dispatch) => {
        !doNotUpdate && user.role !== 'guest' && updateUserData(user);

        dispatch(setDefaultSettings(user.data.settings));
        localStorage.setItem('token', user.data.token);
        localStorage.setItem('token_date', moment().format("YYYY-MM-DD HH:mm:ss"));

        dispatch({
            type: SET_USER_DATA,
            payload: user
        })
        Promise.all([
            dispatch(NotificationActions.generateNotifications(user)),
            dispatch(TableActions.getUserTablePreferences(user.data.auth_id)),
            dispatch(DashboardActions.getLayout(user.data.auth_id, false)),
            dispatch(NotificationActions.getNotifications(user))
        ])

    }
}

export function updateStudentUserCourses(student_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/update_student_courses/' + student_id)
            .then((response) => response.json())
            .then((courses) => {
                dispatch({
                    type: UPDATE_STUDENT_USER_COURSES,
                    payload: courses,
                });
            });
    }
}

export function updateUserRoles(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/auth/update_user_roles/' + auth_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: UPDATE_USER_ROLES,
                    payload: data,
                });
            });
    }
}

export function updateUserSettings(settings) {
    return (dispatch, getState) => {
        const oldUser = getState().auth.user;
        const user = _.merge({}, oldUser, { data: { settings } });
        return dispatch(setUserData(user));
    }
}

export function changeUserType(auth_id, role_id, link_id = 0) {
    return (dispatch) => {
        fetch(server_connection + '/auth/change_role',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, role_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(logoutUser());
            });
    }
}

export function createUserSettings(authUser) {
    return (dispatch, getState) => {
        const guestUser = getState().auth.user;
        const fuseDefaultSettings = getState().fuse.settings.defaults;
        const currentUser = firebase.auth().currentUser;

        /**
         * Merge with current Settings
         */
        const user = _.merge({}, guestUser,
            {
                uid: authUser.uid,
                from: 'firebase',
                role: "admin",
                data: {
                    displayName: authUser.displayName,
                    email: authUser.email,
                    settings: { ...fuseDefaultSettings }
                }
            }
        );
        currentUser.updateProfile(user.data);
        return dispatch(setUserData(user));
    }
}


export function toggleInShortcuts(id) {
    return (dispatch, getState) => {
        let user = getState().auth.user;
        let shortcuts = user.data.shortcuts;
        shortcuts = shortcuts.includes(id) ? shortcuts.filter(_id => id !== _id) : [...shortcuts, id];
        return dispatch(setUserData(
            {
                ...user,
                data: {
                    ...user.data,
                    shortcuts
                }
            }
        ));
    }
}

export function removeUserData() {
    return {
        type: REMOVE_USER_DATA
    }
}

export function logoutUser() {
    window.location.replace(
        `${portal_url}/dashboard`
    );

    localStorage.removeItem('token');

    return (dispatch, getState) => {

        const user = getState().auth.user;

        user.role !== 'guest' && user.from === 'firebase' && auth.signOut();

        dispatch(setDefaultSettings(FuseDefaultSettings));

        dispatch({
            type: USER_LOGGED_OUT
        })
    }
}

export function goToProfile() {
    history.push({
        pathname: '/profile'
    })
    return (dispatch, getState) => {
        dispatch({
            type: GO_TO_PROFILE
        })
    }

}

export function goToCourse(id, unscheduled) {
    return (dispatch, getState) => {
        if (store.getState().dashboardApp.course.course.company_calendar_course_id != id) {
            dispatch(DashboardActions.resetCourseDashboard())
        }
        history.push({
            pathname: '/course-dashboard/' + id + '/' + unscheduled
        })
    }
}

export function goToInstructorCourse(id, unscheduled) {
    return (dispatch, getState) => {
        if (store.getState().dashboardApp.instructorCourse.course.company_calendar_course_id != id) {
            dispatch(DashboardActions.resetInstructorCourseDashboard())
        }
        history.push({
            pathname: '/instructor-course-dashboard/' + id + '/' + unscheduled
        })
    }
}

export function goToNotification(auth_id, notification) {
    return (dispatch, getState) => {
        history.push({
            pathname: '/notification/detail/' + notification.notification_id
        })
    }
}

function updateUserData(user) {
    switch (user.from) {
        case 'firebase':
            {
                fireBaseUpdateUserData(user);
                break;
            }
        default:
            {

            }
    }
}

function fireBaseUpdateUserData(user) {
    db.ref(`users/${user.uid}`)
        .set(user)
        .then(() => {
            store.dispatch(Actions.showMessage({ message: "User data saved to firebase" }));
        })
        .catch(error => {
            store.dispatch(Actions.showMessage({ message: error.message }));
        });
}



// WEBPACK FOOTER //
// src/auth/store/actions/user.actions.js